function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(12098 12502)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-14047.998 -25778)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14065.98,25805.959v0l-4.086-4.084h-5.79v-5.791l-4.105-4.105,4.105-4.1v-5.77h5.771l4.106-4.107,4.1,4.107h5.79v5.783l4.087,4.086-4.087,4.086v5.811h-5.8l-4.086,4.084Zm.262-21.125c-.182,0-.37.008-.515.018a7.191,7.191,0,0,0-4.943,2.455,7.114,7.114,0,0,0-1.753,5.215,7.2,7.2,0,0,0,7.183,6.676c.162,0,.326-.006.518-.02a7.2,7.2,0,0,0,4.947-2.453,7.1,7.1,0,0,0,1.756-5.207A7.224,7.224,0,0,0,14066.242,25784.834Z",
  transform: "translate(-12098 -12498)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.221,
  cy: 5.181,
  rx: 5.221,
  ry: 5.181,
  transform: "translate(1963.007 13288.819)",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  transform: "translate(-12098 -12502)",
  fill: "none"
}));

function SvgIconSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSun);
export default __webpack_public_path__ + "static/media/icon-sun.305b7fb4.svg";
export { ForwardRef as ReactComponent };